import { useCallback, useState } from 'react'

export enum PersistValueKeys {
  UserMenuExpanded = 'user-menu-expanded'
}

export function setPersistedValue(k: string, value: any) {
  localStorage.setItem(k, JSON.stringify(value))
}

export function getPersistedValue(k: string, fallback?: any) {
  const v = JSON.parse(localStorage.getItem(k) as string)

  return v === null ? fallback : v
}

export function usePersistedState<T>(k: PersistValueKeys, fallback?: T): [T, (v: T) => void] {
  const stored = getPersistedValue(k, fallback)

  const [internalState, setInternalState] = useState(stored)
  const setValue = useCallback(
    (v: T) => {
      setInternalState(v)
      setPersistedValue(k, v)
    },
    [k]
  )

  return [internalState, setValue]
}
